import { ProjectEvents } from "../../../helpers/projectEvents";
import { FC } from "react";
import { Project, ProjectUtils } from "@brg/api";
import { ImageRequest } from "../../../constants/imageRequest";
import { Utils } from "../../../helpers/utils/utils";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";
import { CreateLinkTo } from "../../../constants/linkTo";
import { ProjectsGridNew } from "../../../components/grids";
import { ProjectCardDraftNew } from "../../../components/projectCard/ProjectCardDraft";
import { CoreProjectCardContainer, LayoutConst } from "../../../../core";
import { BookEvents } from "_deziiign/books/core/components/helper/bookEvents";
import styled, { useTheme } from "styled-components";
import { AppTester } from "supporting";
import {getPresentationImages} from "../../../helpers/utils/getPresentationImages";

const CreateDraftButton = styled.div`
  cursor: pointer;
  padding: 11px 24px 9px;
  height: 40px;
  min-width: 96px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  background: transparent;
  border: 1px solid ${(p) => p.theme.draftCreate.secondary};
  box-sizing: border-box;
  border-radius: 24px;
  transition: 0.2s;

  font-family: Inter;
  font-weight: normal;
  font-size: 15px;
  line-height: 20px;
  color: ${p => p.theme.draftCreate.secondary};

  :hover {
    border-color: ${p => p.theme.draftCreate.borderHover};
    color: ${p => p.theme.draftCreate.textHover};
  }

  @media (max-width: ${LayoutConst.screen.l - 1}px) {
    white-space: break-spaces;
    min-width: 80px;
    max-width: 130px;
    padding: 12px 25px;
    font-size: 11px;
    line-height: 13px;
  }
`

export interface DesignerTabsProps extends ProjectEvents, BookEvents {
  projects?: Project[];
  activeTabKey: string;
  entityType?: string;
  canCreateProjects?: boolean;
  isExport?: boolean;
  selectedProjects?: string[];
  onSelectProject?: (id: string) => void;
}

export const DraftsGrid: FC<DesignerTabsProps> = (props) => {
  const { t } = useTranslation();

  const {
    activeTabKey,
    projects,
    entityType,
    canCreateProjects = true,
    isExport,
    selectedProjects,
    onSelectProject,
    ...handlers
  } = props;

  const history = useHistory();
  const location = useLocation();
  const theme = useTheme();
  const isBook = AppTester.isBooks();
  const isCGRAVE = AppTester.isCGRAVE();
  const isPro = AppTester.isProHSE() || 
    AppTester.isProDeziiign() || 
    window.location.pathname?.split('/')?.includes('pro')
  const isContinuumSite = AppTester.isContinuumSite();

  if (entityType === 'books') {
    return (<ProjectsGridNew>
      {canCreateProjects && (
        <CoreProjectCardContainer
          onClick={() => {
            if (isPro) {
              window.open(
                process.env.REACT_APP_URL_HSEDESIGN_RU + CreateLinkTo.bookCreate()
                , '_SELF')
              return
            }
            history.push(CreateLinkTo.bookCreate())
          }}
          justify={"center"}
          align={"center"}
          width={"100%"}
          background={theme.draftCreate.primary}
          isCGRAVE={isCGRAVE || isContinuumSite}
        >
          <CreateDraftButton>{t('start_book_title')}</CreateDraftButton>
        </CoreProjectCardContainer>
      )}
      {projects?.map((value) => {
        const { projectId: id } = value;
        return (
          <ProjectCardDraftNew
            title={value.title}
            identifier={id}
            key={id}
            onView={(bookId: string): void => history.push(CreateLinkTo.bookEdit(bookId))}
            onEdit={(bookId: string): void => history.push(CreateLinkTo.bookEdit(bookId))}
            onMoveDrafts={() => handlers.onBookMoveDrafts?.(id)}
            onDelete={() => handlers.onBookDelete?.(id)}
            onPublish={() => handlers.onBookPublish?.(id)}
            isExport={isExport}
            selected={isExport && selectedProjects?.includes(id)}
            onSelect={onSelectProject}
            image={
              ProjectUtils.getTitleImageOrUndefined(
                  {...value, titleImages: value?.titleImages?.length > 0 ? value?.titleImages : getPresentationImages(value)},
                ImageRequest.tile
              ) ?? undefined
            }
            tooltip={{
              isPublishable: false
            }}
          />
        )
      })}
    </ProjectsGridNew>)
  }

  return (
    <ProjectsGridNew>
      {canCreateProjects  && (
        <CoreProjectCardContainer
          onClick={() => history.push((isBook || activeTabKey === 'draft_books') ? CreateLinkTo.bookCreate() : CreateLinkTo.projectCreate())}
          justify={"center"}
          align={"center"}
          width={"100%"}
          background={theme.draftCreate.primary}
          isCGRAVE={isCGRAVE || isContinuumSite}
        >
          <CreateDraftButton>{(isBook || activeTabKey === 'draft_books')  ? t('start_book_title') : t('start_project_title')}</CreateDraftButton>
        </CoreProjectCardContainer>
      )}
      {projects?.map((value) => {
        //@ts-ignore
        const projectType = value?.projectType;
        return (
          <ProjectCardDraftNew
          {...handlers}
          title={value.title}
          //@ts-ignore
          projectType={projectType}
          //@ts-ignore
          projectContexts={value.contexts || value.projectContexts}
          identifier={value.projectId}
          key={value.projectId}
          isExport={isExport}
          selected={isExport && selectedProjects?.includes(value.projectId)}
          onSelect={onSelectProject}
          image={
            ProjectUtils.getTitleImageOrUndefined(
                {...value, titleImages: value?.titleImages?.length > 0 ? value?.titleImages : getPresentationImages(value)},
              ImageRequest.tile
            ) ?? undefined
          }
          tooltip={{
            isPublishable:
              Utils.projectIsFine(value),
          }}
        />
        )
      })}
    </ProjectsGridNew>
  );
};
import { ProjectEvents } from "../../../helpers/projectEvents";
import { FC } from "react";
import { Project, ProjectUtils } from "@brg/api";
import { ImageRequest } from "../../../constants/imageRequest";
import { Utils } from "../../../helpers/utils/utils";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";
import { CreateLinkTo } from "../../../constants/linkTo";
import { ProjectsGridNew } from "../../../components/grids";
import { ProjectCardDraftNew } from "../../../components/projectCard/ProjectCardDraft";
import { CoreProjectCardContainer, LayoutConst } from "../../../../core";
import { BookEvents } from "_deziiign/books/core/components/helper/bookEvents";
import styled, { useTheme } from "styled-components";
import { AppTester } from "supporting";
import {getPresentationImages} from "../../../helpers/utils/getPresentationImages";

const CreateDraftButton = styled.div`
  cursor: pointer;
  padding: 11px 24px 9px;
  height: 40px;
  min-width: 96px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  background: transparent;
  border: 1px solid ${(p) => p.theme.draftCreate.secondary};
  box-sizing: border-box;
  border-radius: 24px;
  transition: 0.2s;

  font-family: Inter;
  font-weight: normal;
  font-size: 15px;
  line-height: 20px;
  color: ${p => p.theme.draftCreate.secondary};

  :hover {
    border-color: ${p => p.theme.draftCreate.borderHover};
    color: ${p => p.theme.draftCreate.textHover};
  }

  @media (max-width: ${LayoutConst.screen.l - 1}px) {
    white-space: break-spaces;
    min-width: 80px;
    max-width: 130px;
    padding: 12px 25px;
    font-size: 11px;
    line-height: 13px;
  }
`

export interface DesignerTabsProps extends ProjectEvents, BookEvents {
  projects?: Project[];
  activeTabKey: string;
  entityType?: string;
  canCreateProjects?: boolean;
  isExport?: boolean;
  selectedProjects?: string[];
  onSelectProject?: (id: string) => void;
}

export const DraftsGrid: FC<DesignerTabsProps> = (props) => {
  const { t } = useTranslation();

  const {
    activeTabKey,
    projects,
    entityType,
    canCreateProjects = true,
    isExport,
    selectedProjects,
    onSelectProject,
    ...handlers
  } = props;

  const history = useHistory();
  const location = useLocation();
  const theme = useTheme();
  const isBook = AppTester.isBooks();
  const isCGRAVE = AppTester.isCGRAVE();
  const isPro = AppTester.isProHSE() || 
    AppTester.isProDeziiign() || 
    window.location.pathname?.split('/')?.includes('pro')
  const isContinuumSite = AppTester.isContinuumSite();

  if (entityType === 'books') {
    return (<ProjectsGridNew>
      {canCreateProjects && (
        <CoreProjectCardContainer
          onClick={() => {
            if (isPro) {
              window.open(
                process.env.REACT_APP_URL_HSEDESIGN_RU + CreateLinkTo.bookCreate()
                , '_SELF')
              return
            }
            history.push(CreateLinkTo.bookCreate())
          }}
          justify={"center"}
          align={"center"}
          width={"100%"}
          background={theme.draftCreate.primary}
          isCGRAVE={isCGRAVE || isContinuumSite}
        >
          <CreateDraftButton>{t('start_book_title')}</CreateDraftButton>
        </CoreProjectCardContainer>
      )}
      {projects?.map((value) => {
        const { projectId: id } = value;
        return (
          <ProjectCardDraftNew
            title={value.title}
            identifier={id}
            key={id}
            onView={(bookId: string): void => history.push(CreateLinkTo.bookEdit(bookId))}
            onEdit={(bookId: string): void => history.push(CreateLinkTo.bookEdit(bookId))}
            onMoveDrafts={() => handlers.onBookMoveDrafts?.(id)}
            onDelete={() => handlers.onBookDelete?.(id)}
            onPublish={() => handlers.onBookPublish?.(id)}
            isExport={isExport}
            selected={isExport && selectedProjects?.includes(id)}
            onSelect={onSelectProject}
            image={
              ProjectUtils.getTitleImageOrUndefined(
                  {...value, titleImages: value?.titleImages?.length > 0 ? value?.titleImages : getPresentationImages(value)},
                ImageRequest.tile
              ) ?? undefined
            }
            tooltip={{
              isPublishable: false
            }}
          />
        )
      })}
    </ProjectsGridNew>)
  }

  return (
    <ProjectsGridNew>
      {canCreateProjects  && (
        <CoreProjectCardContainer
          onClick={() => history.push((isBook || activeTabKey === 'draft_books') ? CreateLinkTo.bookCreate() : CreateLinkTo.projectCreate())}
          justify={"center"}
          align={"center"}
          width={"100%"}
          background={theme.draftCreate.primary}
          isCGRAVE={isCGRAVE || isContinuumSite}
        >
          <CreateDraftButton>{(isBook || activeTabKey === 'draft_books')  ? t('start_book_title') : t('start_project_title')}</CreateDraftButton>
        </CoreProjectCardContainer>
      )}
      {projects?.map((value) => {
        //@ts-ignore
        const projectType = value?.projectType;
        return (
          <ProjectCardDraftNew
          {...handlers}
          title={value.title}
          //@ts-ignore
          projectType={projectType}
          //@ts-ignore
          projectContexts={value.contexts || value.projectContexts}
          identifier={value.projectId}
          key={value.projectId}
          isExport={isExport}
          selected={isExport && selectedProjects?.includes(value.projectId)}
          onSelect={onSelectProject}
          image={
            ProjectUtils.getTitleImageOrUndefined(
                {...value, titleImages: value?.titleImages?.length > 0 ? value?.titleImages : getPresentationImages(value)},
              ImageRequest.tile
            ) ?? undefined
          }
          tooltip={{
            isPublishable:
              Utils.projectIsFine(value),
          }}
        />
        )
      })}
    </ProjectsGridNew>
  );
};
